import {
  backButton,
  init,
  initData,
  miniApp,
  swipeBehavior,
  postEvent,
  viewport,
} from "@telegram-apps/sdk-react";

/**
 * Initializes the application and configures its dependencies.
 */
export async function initSDK(): Promise<string> {
  // Initialize special event handlers for Telegram Desktop, Android, iOS, etc.
  // Also, configure the package.
  init();

  // Eruda — mobile dev console (DOM/Network/Console). Loaded ONLY with an
  // explicit VITE_APP_IS_DEV=true opt-in (env). It no longer auto-loads in
  // local `npm run dev`, because the floating console button overlapped the
  // app UI. Set VITE_APP_IS_DEV=true when you actually need it.
  if (import.meta.env.VITE_APP_IS_DEV === "true") {
    void import("eruda").then(({ default: eruda }) => {
      eruda.init();
      eruda.position({
        x: window.innerWidth - 50,
        y: window.innerHeight - 100,
      });
    });
  }

  // Check if all required components are supported.
  if (!backButton.isSupported() || !miniApp.isSupported()) {
    return Promise.reject("error");
  }

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  setTimeout(async () => {
    if (viewport.mount.isAvailable() && isMobile) {
      await viewport.mount();
      viewport.expand(); // first it would be better to expand
    }
    if (viewport.requestFullscreen.isAvailable() && isMobile) {
      await viewport.requestFullscreen(); // then request full screen mode
    }
  }, 0);

  if (swipeBehavior.mount.isAvailable()) {
    swipeBehavior.mount();
  }
  if (swipeBehavior.disableVertical.isAvailable()) {
    swipeBehavior.disableVertical();
    swipeBehavior.isVerticalEnabled(); // false
  }

  // Mount all components used in the project.
  backButton.mount();
  await miniApp.mount();
  initData.restore();

  // postEvent — miniApp.mount()dan keyin chaqiriladi: iOS Telegram WebView
  // TelegramGameProxy ni asinxron inject qiladi, erta chaqirilsa crash
  // bo'ladi (TypeError: ...TelegramGameProxy.receiveEvent). try-catch transport
  // tayyor bo'lmasa init'ni butunlay yiqitmaslik uchun.
  try {
    postEvent("web_app_set_background_color", {
      color: "#101017",
    });
  } catch (e) {
    console.warn("postEvent set_background_color failed:", e);
  }

  return "done";
}
